@if (folderHideshow) {
  <div class="mat-elevation-z4 primary header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="reminder-title ml-6" fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="s-32 fuse-white-fg">alarm</mat-icon>
      <h2 class="ml-4 font-semibold">Reminder</h2>
    </div>

    <button mat-icon-button class="reminder-close-icon mr-4" (click)="foldSidebarTemporarily()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
@if (!folderHideshow) {
  <div class="alarm-class flex items-center justify-center">
    <button mat-icon-button (click)="unfoldSidebarTemporarily()">
      <mat-icon>alarm</mat-icon>
    </button>
  </div>
}

@if (this.folderHideshow) {
  <div class="content">
    <div id="chat" fxLayout="column" fxFlex="1 1 auto">
      <div id="messages" class="messages" fxFlex="1 1 auto">
        <!-- <ng-container>
        <div class="no-contact-selected">
          <div class="no-contact-icon">
            <mat-icon class="s-128 fade-text">alarm</mat-icon>
          </div>
          <div class="no-contact secondary-text">
            No Reminder Found.
          </div>
        </div>
      </ng-container> -->
        <ng-container>
          <form fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxFlex="1 0 auto"
              class="btm_margin mt-2 mb-2"
            >
              <div class="reminder-large-icon">
                <img
                  [src]="
                    currentUser?.THEMECOLOUR === 'theme-blue-gray-dark' ||
                    currentUser?.THEMECOLOUR === 'theme-pink-dark'
                      ? 'assets/icons/web_app/Tasks Icon Base Style dark mode.svg'
                      : 'assets/icons/web_app/Tasks Icon Base Style light mode.svg'
                  "
                  alt="Tasks"
                />

              </div>
              <div class="text-bold font-semibold">
                <p>
                  Matter:
                  <label>{{ ActiveRow?.SHORTNAME }}</label>
                </p>
                <p>
                  Due Date:
                  <label>{{ ActiveRow?.DUEDATE }}</label>
                </p>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mt-6 mb-6">
              <label>{{ ActiveRow?.DESCRIPTION }}</label>
            </div>
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxFlex="1 0 auto"
              class="overflow-auto"
            >
              <div class="reminder-table-wrap w-full">
                <table mat-table mat-table [dataSource]="taskData" class="mat-elevation-z8">
                  <ng-container matColumnDef="DESCRIPTION">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell mat-cell *matCellDef="let element">
                      {{ element.DESCRIPTION }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="STARTDATE">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef>Original Date</th>
                    <td mat-cell mat-cell *matCellDef="let element">
                      {{ element.STARTDATE }}
                    </td>
                  </ng-container>
                  <tr mat-header-row mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="ActiveRow = row; highlightedRows = row.TASKGUID"
                    [style.background]="highlightedRows == row.TASKGUID ? selectedColore : ''"
                    [ngClass]="
                      highlightedRows == row.TASKGUID
                        ? 'row-text-colore row-text-colore-reminder'
                        : ''
                    "
                  ></tr>
                </table>
              </div>
            </div>
            <div class="popup_ftr remindertask-btns mt-4 px-0">
              <div class="left_popup_btn">
                <button
                  type="button"
                  matButton="filled"
                  color="accent"
                  (click)="dissmissAll()"
                  [disabled]="dissallSpiner"
                >
                  <mat-icon>
                    <img src="assets/icons/web_app/icon_cancel_d.ico" />
                  </mat-icon>
                  @if (dissallSpiner) {
                    <mat-spinner diameter="24"></mat-spinner>
                  }
                  Dismiss All
                </button>
              </div>
              <div class="right_popup_btn flex gap-1">
                <button
                  type="button"
                  matButton="filled"
                  color="accent"
                  (click)="editData(ActiveRow)"
                >
                  <img
                    [src]="
                      currentUser?.THEMECOLOUR === 'theme-blue-gray-dark' ||
                      currentUser?.THEMECOLOUR === 'theme-pink-dark'
                        ? 'assets/icons/web_app/Tasks Icon Base Style dark mode.svg'
                        : 'assets/icons/web_app/Tasks Icon Base Style light mode.svg'
                    "
                    alt="Tasks"
                  />

                  Open Item
                </button>
                <button
                  type="button"
                  matButton="tonal"
                  color="primary"
                  class="dismiss-button"
                  cdkFocusInitial
                  (click)="dissmiss(ActiveRow)"
                  [disabled]="dissSpiner"
                >
                  <mat-icon>
                    <img src="assets/icons/web_app/icon_cancel_d.ico" />
                  </mat-icon>
                  @if (dissSpiner) {
                    <mat-spinner diameter="24"></mat-spinner>
                  }
                  Dismiss
                </button>
              </div>
            </div>
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxFlex="1 0 auto"
              class="btm_margin my-4"
            >
              <mat-form-field appearance="outline" fxFlex="70" class="pr-1">
                <mat-label>Snooze</mat-label>
                <mat-select
                  [(ngModel)]="SnoozeTime"
                  name="SnoozeTime"
                  (selectionChange)="onSnoozeTimeChange($event.value)"
                >
                  <mat-option value="MINUTES:5">5 Minutes</mat-option>
                  <mat-option value="MINUTES:10">10 Minutes</mat-option>
                  <mat-option value="MINUTES:15">15 Minutes</mat-option>
                  <mat-option value="MINUTES:30">30 Minutes</mat-option>
                  <mat-option value="MINUTES:60">1 Hours</mat-option>
                  <mat-option value="MINUTES:120">2 Hours</mat-option>
                  <mat-option value="MINUTES:240">4 Hours</mat-option>
                  <mat-option value="MINUTES:480">8 Hours</mat-option>
                  <mat-option value="DAYS:1">1 Days</mat-option>
                  <mat-option value="DAYS:2">2 Days</mat-option>
                  <mat-option value="DAYS:3">3 Days</mat-option>
                  <mat-option value="DAYS:4">4 Days</mat-option>
                  <mat-option value="DAYS:7">1 Week</mat-option>
                </mat-select>
              </mat-form-field>
              <button
                type="button"
                class="snooze-btn-margin dismiss-button"
                matButton="tonal"
                color="primary"
                fxFlex="30"
                cdkFocusInitial
                [disabled]="SnoozeSpiner"
                (click)="Snooze(ActiveRow)"
              >
                <mat-icon>
                  <img src="assets/icons/web_app/icon_save_d.ico" />
                </mat-icon>
                @if (SnoozeSpiner) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Snooze
              </button>
            </div>
          </form>
        </ng-container>
      </div>
    </div>
  </div>
}
